export * from "./Footer";
export { default as SmallFooter } from "./SmallFooter";



// WEBPACK FOOTER //
// ./src/components/footer/index.ts